import React from "react";
import "./awardCard.scss";
// Import medal image
import GoldMedal from "../../assets/NewBanner/BlackCoin.png";
import Brand from "../../assets/NewBanner/BottleImage.svg";
// import AwardCardBg from "../../assets/NewBanner/AwardCardBg.svg";

const AwardCard = ({ award = {}, products = [] }) => {
  // Default values if props are not provided
  const {
    medalImage = GoldMedal,
    title = "Gold Medal",
    description = "A Gold Medal is awarded to spirits that are exceptional, with outstanding character and complexity."
  } = award;

  // Ensure products is an array and limit to max 2 products
  const productsList = Array.isArray(products) ? products.slice(0, 2) : [];
  const hasMultipleProducts = productsList.length === 2;

  return (
    <div className="awardCardContainer">
      <div className="awardMainCard">
        <div className="awardCardMedal">
          <img src={medalImage} alt={title} className="medalImage" />
          <div className="medalDetails">
            <h2 className="awardCardTitle">{title}</h2>
            <p className="awardCardDescription">{description}</p>
          </div>
        </div>
        <div className="awardCardDetails">
          <div className="recipientWrapper">
            <div className="doubleLine">
              <div className="line"></div>
              <div className="line"></div>
            </div>
            <p className="awardCardRecipient">Awarded To</p>
            <div className="doubleLine">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>

          <div
            className={`awardCardProductInfo ${hasMultipleProducts ? "multipleProducts" : ""}`}
          >
            {productsList.map((product, index) => (
              <React.Fragment key={index}>
                {/* Product Item */}
                <div className="productItem">
                  <div className="productDetails">
                    <span className="productName">
                      {product.name ||
                        "Tharra Company Paani Vodka (36%, Idaho, USA)"}
                    </span>
                  </div>
                  <div className="productImageContainer">
                    <img
                      src={product.image || Brand}
                      alt={product.name || "Product"}
                      className="productImage"
                    />
                  </div>
                </div>

                {/* Separator line between products */}
                {hasMultipleProducts && index === 0 && (
                  <div className="productSeparator"></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardCard;
